module.exports = __webpack_public_path__ + "static/media/welcome-slider-3-en-md.c3cd282b.png";